import apiClient from "./apiClient";
import storageService from "../utils/storageService";

/**
 * Fetches and sets tenant-specific logo, name, and color based on the current subdomain.
 * Mirrors the Angular 'ChangedTenantLogoService' flow.
 */
export const fetchAndSetTenantBranding = async () => {
    try {
        const response = await apiClient.get('/TenantDetails');

        // Handle axios response wrapper
        const resData = response.data;

        if (resData?.isSuccess && resData?.data && resData.data.length > 0) {
            const tenantData = resData.data[0];

            if (tenantData.TenantCName) {
                storageService.setItem('Tenant_CName', tenantData.TenantCName);
            }
            if (tenantData.TenantLogo) {
                storageService.setItem('Tenant_Logo', tenantData.TenantLogo);
            }
            if (tenantData.TenantColorCode) {
                storageService.setItem('Tenant_Color', tenantData.TenantColorCode);
                // Optionally dispatch an event to let React components know the theme changed
                window.dispatchEvent(new Event('theme_updated'));
            }

        } else {
            console.warn("No tenant branding data found or request failed.", resData);
        }
    } catch (error) {
        console.error("Failed to fetch tenant branding details", error);
    }
};
